(function () {
    'use strict';

    angular
        .module('atheer.session')
        .service('SessionsService', SessionsService);

    /* @ngInject */
    function SessionsService($mdDialog, $state, deviceDetector, Feature, PermissionService, Principal, $http, $q, Setting, $rootScope) {
        var annotationImage;

        var service = {
            startInstantSession: startInstantSession,
            startSession: startSession,
            joinSession: joinSession,
            exportSessionsReport: exportSessionsReport,
            isTranscriptionFeatureAvailable: isTranscriptionFeatureAvailable,
            isTranslationFeatureAvailable: isTranslationFeatureAvailable,
            isCaptionsFeatureAvailable: isCaptionsFeatureAvailable,
            getDefaultTranscriptionLanguage: getDefaultTranscriptionLanguage,
            getCaptionsSupportedLanguagesList: getCaptionsSupportedLanguagesList,
            isAISummaryFeatureAvailable: isAISummaryFeatureAvailable
        };
        return service;

        function startInstantSession() {
            $mdDialog
                .show({
                    templateUrl: 'modules/session/session-start-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: 'SessionStartController',
                    controllerAs: 'vm',
                    locals: {
                        filter: null,
                        conversation: null,
                        isMobileBrowser: deviceDetector.isMobile()
                    }
                })
                .then(function (result) { });
        };

        function joinSession() {
            $mdDialog
                .show({
                    templateUrl: 'modules/session/session-join-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: 'SessionJoinController',
                    controllerAs: 'vm',
                    locals: {
                        sessionNo: null,
                        isMobileBrowser: deviceDetector.isMobile()
                    }
                })
                .then(function (result) { });
        };

        function startSession() {
            $state.go('storm.sessions.player', {
                session_no: entity.session_no
            });
        };

        function exportSessionsReport() {
            $mdDialog.show({
                templateUrl: 'modules/session/session-summary-report.tmpl.html',
                clickOutsideToClose: true,
                controller: "sessionSummaryReportController",
                controllerAs: "vm",
            }).then(function (result) {

            });

        }

        function getDefaultTranscriptionLanguage() {
            var profileLanguage = Principal.getUserInfo().hasOwnProperty(
                "language_id"
            )
                ? Principal.getUserInfo().language_id.replace("_", "-")
                : null;
            if (
                !!profileLanguage &&
                getCaptionsSupportedLanguagesList().hasOwnProperty(profileLanguage)
            ) { 
                return profileLanguage;
            }
            return 'en-US';
        }

        function isTranscriptionFeatureAvailable() {
            return (
                Feature.isActive("feature_atheerAiRO_enableAiROTranscription")
            );
        }

        function isTranslationFeatureAvailable() {
            return (
                Feature.isActive("feature_atheerAiRO_enableAiROTranslation")
            );
        }

        function isAISummaryFeatureAvailable() {
            return (
                Feature.isActive("feature_atheerAiRO_enableAiROSummary")
            );
        }

        function isCaptionsFeatureAvailable() {
            return Feature.isActive("feature_airsession_enable_closed_caption");
        }

        function getCaptionsSupportedLanguagesList() {
            return {
                "en-US": { "id": "en-US", "code": "en", "name": "English" },
                "fr-FR": { "id": "fr-FR", "code": "fr", "name": "French" },
                "de-DE": { "id": "de-DE", "code": "de", "name": "German" },
                "es-CL": { "id": "es-CL", "code": "es", "name": "Spanish" },
                "pl-PL": { "id": "pl-PL", "code": "pl", "name": "Polish" },
                "nl-NL": { "id": "nl-NL", "code": "nl", "name": "Dutch" },
                "it-IT": { "id": "it-IT", "code": "it", "name": "Italian" },
                "pt-BR": { "id": "pt-BR", "code": "pt", "name": "Portuguese" },
                "sv-SE": { "id": "sv-SE", "code": "sv", "name": "Swedish" },
                "tr-TR": { "id": "tr-TR", "code": "tr", "name": "Turkish" },
                "zh-TW": { "id": "zh-TW", "code": "zh-TW", "name": "Chinese" }
            };
        }
    }
})();
